
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strumenti-servizi/service-gift",
      function () {
        return require("private-next-pages/strumenti-servizi/service-gift/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strumenti-servizi/service-gift"])
      });
    }
  